import React, { useRef, useState } from 'react';
import { Button } from '@alefeducation/ui-elements-library-core/lib/Button';
import {
  Upload,
  Image,
  TrashSolid,
} from '@alefeducation/ui-elements-library-icons';
import styled from 'styled-components';

interface FileInputButtonProps {
  onFilesSelected: (files: File[]) => void;
  onFilesRemoved: () => void;
}

const StyledContainer = styled.div`
  button {
    width: 100%;
  }
  .delete-icon {
    cursor: pointer;
  }
`;

const ImageWithFileName = styled.div`
  display: flex;
  align-items: center;
`;

const StyledButton = styled(Button)`
  width: 100%
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 10px, 24px, 10px, 16px;
  > span {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
`;

const FileName = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: 8px;
`;

const DeleteIcon = styled.span`
  height: 17px;
  cursor: pointer;
  align-self: flex-end;
`;

const FileInputButton: React.FC<FileInputButtonProps> = ({
  onFilesSelected,
  onFilesRemoved,
}) => {
  const [files, setFiles] = useState<File[]>([]);
  const fileInputRef = useRef(null);

  // @ts-ignore
  const handleFileChange = (event) => {
    const fileList: File[] = event.target.files;
    if (fileList && fileList.length > 0) {
      setFiles(fileList);
      onFilesSelected(fileList);
    }
  };

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      // @ts-ignore
      fileInputRef.current.click();
    }
  };

  const handleRemoveFile = () => {
    setFiles([]);
    onFilesRemoved();
  };

  return (
    <StyledContainer>
      <input
        type="file"
        multiple
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
      {files.length === 0 ? (
        <Button
          data-testid={'upload-file-button'}
          variant="secondary"
          icon={<Upload />}
          onClick={handleButtonClick}
        >
          Select a File
        </Button>
      ) : (
        <StyledButton variant="secondary">
          <ImageWithFileName>
            <Image />
            <FileName>
              {files.length === 1
                ? files[0].name
                : `${files.length} files selected`}
            </FileName>
          </ImageWithFileName>
          <DeleteIcon onClick={handleRemoveFile}>
            <TrashSolid />
          </DeleteIcon>
        </StyledButton>
      )}
    </StyledContainer>
  );
};

export default FileInputButton;
